import type { Theme } from "@mui/material";

const SHADOWS = {
  default: "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
  pressed: "0 4px 18px 3px rgba(0, 0, 0, 0.12), 0 10px 14px 1px rgba(0, 0, 0, 0.14), 0 6px 6px -3px rgba(0, 0, 0, 0.20)",
} as const;

const getCommonButtonStyles = (theme: Theme) => ({
  borderRadius: "100px",
  border: `2px solid ${theme.palette.helpWidget.border}`,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.helpWidget.border,
  position: "relative" as const,
  transition: "all 0.2s ease-in-out",
});

const getFocusRingStyles = () => ({
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-8px",
    left: "-8px",
    right: "-8px",
    bottom: "-8px",
    border: "2px solid rgba(0, 0, 0, 1)",
    borderRadius: "4px",
    pointerEvents: "none",
    zIndex: -1,
  },
  "&::after": {
    content: '""',
    position: "absolute",
    top: "-10px",
    left: "-10px",
    right: "-10px",
    bottom: "-10px",
    border: "2px solid rgba(255, 255, 255, 1)",
    borderRadius: "4px",
    pointerEvents: "none",
    zIndex: -2,
  },
});

export const getHelpWidgetStyles = (theme: Theme, isMobile: boolean) => ({
  button: {
    ...getCommonButtonStyles(theme),
    boxShadow: SHADOWS.default,
    
    "&:hover": {
      backgroundColor: theme.palette.helpWidget.dark,
      border: `2px solid ${theme.palette.helpWidget.border}`,
    },

    "&:focus": {
      outline: "none",
    },
    
    "&:focus-visible": {
      borderRadius: "100px",
      backgroundColor: theme.palette.primary.main,
      border: `2px solid ${theme.palette.helpWidget.border}`,
      boxShadow: SHADOWS.default,
      outline: "none !important",
      ...getFocusRingStyles(),
    },
    
    "&:active": {
      backgroundColor: theme.palette.helpWidget.dark,
      border: `2px solid ${theme.palette.helpWidget.border}`,
      boxShadow: SHADOWS.pressed,
      "&::before, &::after": {
        display: "none",
      },
    },
  },
  
  container: {
    "& .embeddedMessagingFrame": {
      position: "fixed" as const,
      bottom: isMobile ? "16px" : "24px",
      right: isMobile ? "16px" : "24px",
      maxWidth: `${theme.breakpoints.values.sm}px`,
      width: isMobile
        ? "calc(100% - 32px)"
        : `${theme.breakpoints.values.sm}px`,
      height: "80%",
      maxHeight: "600px",
      zIndex: 10000,
    },
    "& .embeddedMessagingConversationButton": {
      display: "none !important",
    },
  },
  
  fabButton: {
    position: "fixed" as const,
    bottom: isMobile ? "16px" : "24px",
    right: isMobile ? "16px" : "24px",
    zIndex: 9999,
    ...(isMobile ? {} : {
      width: "97px",
      height: "40px",
      padding: "8px 16px",
      gap: "8px",
      display: "flex",
      alignItems: "center",
    }),
  },
  
  icon: {
    width: 24,
    height: 24,
  },
  
  minimizedButton: {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.helpWidget.dark,
      border: `2px solid ${theme.palette.helpWidget.border}`,
    },
    "&:focus-visible": {
      backgroundColor: theme.palette.primary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.helpWidget.dark,
    },
  },
});
